import React, { FC } from 'react'
import { ServerExperiments } from '@/experimentation'
import { PageGiveawayContent } from '@/services/GiveawayService/GiveawayService'
import { PhaseSlugForTracking } from '@/services/ProjectPhaseService'
import { ShopifyProductWithBundles } from '@/services/Shopify/ShopifyService'
import { SweepstakeObject } from '@/types/codegen-federation'
import { GiveawayLayout } from './GiveawayLayout'
import { GiveawayContextProvider } from './context/GiveawayContext'

interface Props {
  content: PageGiveawayContent
  theatricalSlug: string
  tickets: ShopifyProductWithBundles[] | null
  sweepstake: SweepstakeObject
  phase: PhaseSlugForTracking
  experiments?: ServerExperiments
  releaseDate: string | null
}

export const GiveawayView: FC<Props> = ({
  content,
  tickets,
  theatricalSlug,
  phase,
  sweepstake,
  experiments,
  releaseDate,
}) => {
  return (
    <GiveawayContextProvider
      content={content}
      theatricalSlug={theatricalSlug}
      tickets={tickets}
      sweepstake={sweepstake}
      phase={phase}
      experiments={experiments}
      releaseDate={releaseDate}
    >
      <GiveawayLayout />
    </GiveawayContextProvider>
  )
}
